import { render } from "./Banner.vue?vue&type=template&id=bfe613b2"
import script from "./Banner.vue?vue&type=script&lang=js"
export * from "./Banner.vue?vue&type=script&lang=js"
script.render = render

export default script